import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Loader, Checkbox, Button } from 'semantic-ui-react';
import PanelLayout from '../panel/layout';
import Preview from '../export/preview';
import * as shared from '../assets/shared.module.scss';
import * as classes from './styles.module.scss';
import Const from '../../config/const';

const KINDS = ['top', 'bottom', 'left', 'right'];

export default class Hanging extends PureComponent {
  static propTypes = {
    closePanel: PropTypes.func.isRequired,
    load: PropTypes.func.isRequired,
    update: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,

    worksExtended: PropTypes.array.isRequired,
    previewConfig: PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number,
      x: PropTypes.number,
      y: PropTypes.number
    }).isRequired,

    loading: PropTypes.bool.isRequired,
    hangingVariations: PropTypes.array,
    markPositions: PropTypes.object,
    wallHeight: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.state = { canSave: false, image: null };
  }

  componentDidMount() {
    const { load } = this.props;
    load();
  }

  onBuildStarted = () => this.setState({ canSave: false, image: null });

  onBuildComplete = (image, canSave) => this.setState({ canSave, image });

  onChecked(index, kind, checked) {
    const { hangingVariations, update } = this.props;
    const { first, second } = hangingVariations[index];
    if (checked) {
      update(first, second, kind, true);
    } else {
      update(first, second, kind, false);
    }
  }

  save = () => {
    const { save } = this.props;
    const { image } = this.state;
    save(image);
  };

  // eslint-disable-next-line class-methods-use-this
  renderKind(kind, kinds, index) {
    const isChecked = kinds.includes(kind);
    return (
      <Checkbox
        label={ kind }
        checked={ isChecked }
        key={ `${ index }-${ kind }` }
        onChange={ (e, { checked }) => this.onChecked(index, kind, checked) }
      />
    );
  }

  // eslint-disable-next-line class-methods-use-this
  renderVariation(variation, index) {
    // const {  }
    const {
      i0, i1, kinds // , first, second, kinds
    } = variation;
    return (
      <div key={ index }>
        <span>
          { i0 + 1 }
        </span>
        &larr;
        &rarr;
        <span>
          { i1 + 1 }
        </span>
        { KINDS.map((k) => this.renderKind(k, kinds, index)) }
      </div>
    );
  }

  renderContent() {
    const {
      loading, hangingVariations, worksExtended, previewConfig,
      markPositions, reset, wallHeight
    } = this.props;

    if (loading || !hangingVariations.length) {
      return (
        <Loader size="mini" active inline />
      );
    }

    const previewProps = {
      worksExtended,
      previewConfig,
      onBuildStarted: this.onBuildStarted,
      onBuildComplete: this.onBuildComplete,
      currentColor: '#fff',
      onlyPlaceHolders: true,
      markPositions,
      hangingVariations,
      display: true,
      wallHeight
    };

    const { canSave } = this.state;

    const renderSave = canSave ? (
      <Button onClick={ this.save } color="black">Save</Button>
    ) : null;

    return (
      <>
        <Preview { ...previewProps } />
        <div className={ shared.holder }>
          <div className={ classnames(shared.scroll, classes.scroll) }>
            <div>
              <Button onClick={ reset } color="black">Reset</Button>
              { renderSave }
            </div>
            <div className={ classes.marks }>
              { hangingVariations.map((hv, index) => this.renderVariation(hv, index)) }
            </div>
          </div>
        </div>
      </>
    );
  }

  render() {
    const { closePanel } = this.props;

    return (
      <PanelLayout
        title="Hanging Instructions"
        onClose={ () => closePanel(Const.panelKinds.hanging) }
      >
        <div className={ shared.container }>
          { this.renderContent() }
        </div>
      </PanelLayout>
    );
  }
}
